import bindAllOfThis from "src/utils/BindThisHelper";
import { PhaserButtonConfig, PhaserButton } from "src/games/shared/Button";
import TranslateApi from "src/utils/TranslateHelper";
import { MainScene } from "./MainScene";
import { Color } from "src/games/shared/ColorValue";
import { GameState } from "src/games/DiseasedTreesGame/objects/GameState";
import { HowToPlayScene } from "./IntroductionScene";

export class InstructionScene extends Phaser.Scene {
    gameWidth: number;
    gameHeight: number;
    background: Phaser.GameObjects.Image;
    private translateString = "DiseasedTrees.Phaser.InstructionScene.";

    gameScene: typeof Phaser.Scene = MainScene;

    constructor() {
        super({
            key: "LandscapeInstructions"
        });
    }

    preload(): void {
        this.load.image("pixel", require("/src/assets/qci/sprites/pixel.png"));
        this.load.atlas("trees", require("/src/assets/qci/atlas/gameDiseasedTrees.png"), require("/src/assets/qci/atlas/gameDiseasedTrees.json"));
        this.load.image('terrain', require("/src/assets/qci/backgrounds/terrains/r.png"));        
    }

    create(): void {
        this.gameWidth = this.textures.game.config.width as number;
        this.gameHeight = this.textures.game.config.height as number;
        bindAllOfThis(this, InstructionScene.prototype);

        let sky = this.add.image(0, 0, "pixel");
        sky.setOrigin(0);
        sky.setDisplaySize(this.gameWidth, this.gameHeight);
        sky.setTint(0x6eb8e5, 0x6eb8e5, 0xffffff, 0xffffff); // Gradient sky!

        let terrain = this.add.image(0, 400, "terrain");
        terrain.setScale(0.8);
        terrain.setOrigin(0);

        this.addTrees();
        this.addInstruction();
        this.addButtons();
    }

    addTrees(): void {
        let healthy = this.add.image(this.gameWidth / 3, this.gameHeight / 2 + 70, "trees", "tree-1");
        healthy.setDepth(1);

        let diseased = this.add.image(2 * this.gameWidth / 3, this.gameHeight / 2 + 40, "trees", "tree-1");
        diseased.setDepth(1).setTint(0xff8e51);
    }

    addInstruction(): void {
        var textStyle = { fontFamily: 'Roboto Mono, Arial', color: "#F8E71C", fontSize: 30, padding: 10 };
        
        let diseasedText = TranslateApi.translate(this.translateString + "diseased");
        let diseasedTextOb = this.add.text(2 * this.gameWidth / 3, 230, diseasedText, textStyle).setDepth(3);
        diseasedTextOb.setBackgroundColor("#000000").setOrigin(.5);
        let diseasedBorder = this.add.image(diseasedTextOb.x, diseasedTextOb.y, "pixel").setDepth(1);
        diseasedBorder.setDisplaySize(diseasedTextOb.displayWidth + 10, diseasedTextOb.displayHeight + 10).setTint(0x00de0e).setOrigin(.5);

        let healthyText = TranslateApi.translate(this.translateString + "healthy");
        let healthyTextOb = this.add.text(this.gameWidth / 3, 230, healthyText, textStyle).setDepth(3);
        healthyTextOb.setBackgroundColor("#000000").setOrigin(.5);
        let healthyBorder = this.add.image(healthyTextOb.x, healthyTextOb.y, "pixel").setDepth(1);
        healthyBorder.setDisplaySize(healthyTextOb.displayWidth + 10, healthyTextOb.displayHeight + 10).setTint(0x00de0e).setOrigin(.5);
    }

    addButtons(): void {
        let config = new PhaserButtonConfig();
        config.backgroundColor = Color.KUDER_SECONDARY_BUTTON;
        config.smartSize = true;
        config.keyMapping = "keydown_RIGHT";
        
        let txt = TranslateApi.translate(this.translateString + "go");
        
        let button = new PhaserButton(this, this.gameWidth - 150, this.gameHeight - 100, 150, 60, txt, config).setDepth(0);
        button.on('buttonClicked', () => {
            this.scene.remove(this);
            GameState.current = GameState.GAME_STATES[0];
            this.scene.add("GameScene", this.gameScene, true);
        });

        var back = PhaserButton.createQuickBackButton(this, 50, this.gameHeight - 100);
        back.on("buttonClicked", () => {
            this.input.enabled = false;
            this.scene.remove(this);
            this.scene.add("GameIntroScene", HowToPlayScene, true);
        });

    }
}



// WEBPACK FOOTER //
// ./src/games/DiseasedTreesGame/scenes/InstructionScene.ts